import React from 'react';
import ReactDOM from 'react-dom';
import RouteConfig from './RouteConfig';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../src/global.css';

ReactDOM.render(
    <RouteConfig />,
  document.getElementById('root')
);


